import React from 'react'

import { makeStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
// import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { Grid, Input, Slider, Checkbox, CircularProgress, Snackbar } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
const emptypng = "data:image/png;base64,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";

var axios = require("axios");

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        overflow: "none"
    },
    button: {
        marginRight: theme.spacing(1),
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    cardCategoryWhite: {
        color: "rgba(255,255,255,.62)",
        margin: "0",
        fontSize: "14px",
        marginTop: "0",
        marginBottom: "0"
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none"
    },
}));

//Stepper Array
function getSteps() {
    return ['Uplaod background image', 'Uplaod foreground image', 'Set camera position'];
}

//Stepper Components
function getStepContent(step, moveX, moveY, scale, setMoveX, setMoveY, setScale, background, foreground, setBackground, setForeground, loading, handleNext, setSnackbarSeverity, setOpenSnackbar, setSnackbarMsg) {
    switch (step) {
        case 0:
            return <BackgroundUpload background={background} setBackground={setBackground} setSnackbarSeverity={setSnackbarSeverity} setOpenSnackbar={setOpenSnackbar} setSnackbarMsg={setSnackbarMsg}></BackgroundUpload>;
        case 1:
            return <ForegroundUpload foreground={foreground} setForeground={setForeground} handleNext={handleNext} setSnackbarSeverity={setSnackbarSeverity} setOpenSnackbar={setOpenSnackbar} setSnackbarMsg={setSnackbarMsg}></ForegroundUpload>;
        case 2:
            return <SceneEditor moveX={moveX} moveY={moveY} scale={scale} setMoveX={setMoveX} setMoveY={setMoveY} setScale={setScale} foreground={foreground} background={background} loading={loading} setSnackbarSeverity={setSnackbarSeverity} setOpenSnackbar={setOpenSnackbar} setSnackbarMsg={setSnackbarMsg}></SceneEditor>;
        case 3:
            return <h3>Möchtest du die Szene für eine oder mehrere Selfieboxen setzen?</h3>;
        default:
            return 'Unknown step';
    }
}


export default function AddScene() {
    //States for SceneData
    const [moveX, setMoveX] = React.useState(0);
    const [moveY, setMoveY] = React.useState(0);
    const [scale, setScale] = React.useState(1);
    const [background, setBackground] = React.useState(undefined);
    const [foreground, setForeground] = React.useState(undefined);

    //Editor states
    const [loading, setLoading] = React.useState(false);
    const classes = useStyles();
    const [activeStep, setActiveStep] = React.useState(0);
    const steps = getSteps();

    //Snackbar states
    const [openSnackbar, setOpenSnackbar] = React.useState(false);
    const [snackbarMsg, setSnackbarMsg] = React.useState("");
    const [snackbarSeverity, setSnackbarSeverity] = React.useState("");

    //closeSnackbar
    function handleSnackbarClose() {
        setOpenSnackbar(false);
        setSnackbarMsg("");
    }

    //handle next Step
    const handleNext = () => {
        if (activeStep == 2) {
            //Add Custom Scene
            axios.post(window.serverip + "/newCustomScene/" + window.centerids[0], {
                moveX: moveX,
                moveY: moveY,
                scale: scale,
                foreground: foreground,
                background: background,
                sessionid: sessionStorage.getItem("sessionid")
            })
                .then((response) => {
                    setActiveStep((prevActiveStep) => prevActiveStep + 1);
                    setLoading(false);
                    setSnackbarSeverity("success");
                    setSnackbarMsg("Scene added successfully.");
                    setOpenSnackbar(true);
                }, (error) => {
                    setActiveStep((prevActiveStep) => prevActiveStep + 1);
                    setLoading(false);
                    setSnackbarSeverity("error");
                    setSnackbarMsg("network error");
                    setOpenSnackbar(true);
                });

            //reset variables for another scene.
            setMoveX(0);
            setMoveY(0);
            setScale(1);
            setBackground(undefined);
            setForeground(undefined);
            setLoading(true);
        } else {
            //next Step
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
        }
    };

    //handle back
    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    //handle start over
    const handleReset = () => {
        setActiveStep(0);
    };

    //only allow next if background, foreground is set
    function checkNextDisabled() {
        if (activeStep == 0) {
            if (background == undefined) {
                return true;
            }
        }
        if (activeStep == 1) {
            if (foreground == undefined) {
                return true;
            }
        }
        return false;
    }


    return (
        <Card>
            <CardHeader color="primary">
                <h4 className={classes.cardTitleWhite}>Scenes</h4>
                <p className={classes.cardCategoryWhite}>!IMPORTANT! Image filesize max. 10MB</p>
                <p className={classes.cardCategoryWhite}>!IMPORTANT! Image fixed resolution 1920x1080px</p>
                <p className={classes.cardCategoryWhite}>!IMPORTANT! File extension needs to be .png</p>
            </CardHeader>
            <CardBody>
                <Grid container spacing={6} justify="center">
                    <Grid item xs={12}>
                        <Snackbar open={openSnackbar} autoHideDuration={10000} onClose={handleSnackbarClose}>
                            <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} >
                                {snackbarMsg}
                            </Alert>
                        </Snackbar>
                        <Stepper activeStep={activeStep} alternativeLabel>
                            {steps.map((label) => (
                                <Step key={label}>
                                    <StepLabel>{label}</StepLabel>
                                </Step>
                            ))}
                        </Stepper>
                    </Grid>

                    {activeStep === steps.length ? (
                        <Grid item xs={12}>
                            <Typography className={classes.instructions}>Success</Typography>
                            <Button onClick={handleReset}>Add another scene?</Button>
                        </Grid>
                    ) : (
                        <Grid item xs={12}>
                            {getStepContent(activeStep, moveX, moveY, scale, setMoveX, setMoveY, setScale, background, foreground, setBackground, setForeground, loading, handleNext, setSnackbarSeverity, setOpenSnackbar, setSnackbarMsg)}

                        </Grid>
                    )}

                    <Grid item xs={6}>
                        <Button
                            fullWidth
                            disabled={activeStep === 0}
                            onClick={handleBack}
                            className={classes.backButton}
                        >
                            Back
                        </Button>
                    </Grid>
                    <Grid item xs={6}>

                        {activeStep == 1 && foreground == undefined ?

                            <Button fullWidth color="primary" onClick={() => {
                                setForeground(emptypng);
                                handleNext();
                            }}>
                                Skip
                            </Button> : <Button fullWidth variant="contained" color="primary" onClick={handleNext} disabled={checkNextDisabled()}>
                                {activeStep === steps.length - 1 ? 'Create scene' : 'Next'}
                            </Button>}
                    </Grid>
                </Grid>
            </CardBody>

        </Card>

    );
}

//Functional Component for addinng Backgrounds
function BackgroundUpload(props) {
    const background = props.background;
    const setBackground = props.setBackground;

    var checkedbg = false;

    if (background != undefined) {
        checkedbg = true;
    }

    function handleBackground(event) {
        if (event.target.files[0].size > 10000000) {
            props.setSnackbarSeverity("error");
            props.setSnackbarMsg("File is larger than 10MB.");
            props.setOpenSnackbar(true);
            return;
        }
        event.persist();
        var reader = new FileReader();

        reader.readAsDataURL(event.target.files[0]);
        reader.onload = function (e) {
            var image = new Image();
            image.src = e.target.result;
            image.onload = function () {
                var height = this.height;
                var width = this.width;
                if (height == 1080 && width == 1920) {
                    setBackground(reader.result);
                    props.setSnackbarSeverity("success");
                    props.setSnackbarMsg("Background added succesfully");
                    props.setOpenSnackbar(true);
                } else {
                    props.setSnackbarSeverity("error");
                    props.setSnackbarMsg("Dimension have to be 1920x1080");
                    props.setOpenSnackbar(true);
                }
            };
        }
    }

    return (
        <Grid container spacing={6}>
            <Grid item xs={6}>
                <Input fullWidth type="file" onChange={handleBackground} inputProps={{ accept: "image/png" }}></Input>
            </Grid>
            <Grid item xs={6}>
                {background != undefined ? <img src={background} style={{ width: "100%" }} />
                    : null}
            </Grid>
        </Grid>
    );
}

//Functional Component for adding Foregrounds
function ForegroundUpload(props) {
    const foreground = props.foreground;
    const setForeground = props.setForeground;

    var checkedfg = false;

    if (foreground != undefined) {
        checkedfg = true;
    }

    function handleForeground(event) {
        if (event.target.files[0].size > 10000000) {
            props.setSnackbarSeverity("error");
            props.setSnackbarMsg("File is larger than 10MB.");
            props.setOpenSnackbar(true);
            return;
        }
        event.persist();
        var reader = new FileReader();

        reader.readAsDataURL(event.target.files[0]);
        reader.onload = function (e) {
            var image = new Image();
            image.src = e.target.result;
            image.onload = function () {
                var height = this.height;
                var width = this.width;
                if (height == 1080 && width == 1920) {
                    setForeground(reader.result);
                    props.setSnackbarSeverity("success");
                    props.setSnackbarMsg("Background added succesfully");
                    props.setOpenSnackbar(true);
                } else {
                    props.setSnackbarSeverity("error");
                    props.setSnackbarMsg("Dimension have to be 1920x1080px");
                    props.setOpenSnackbar(true);
                }
            };
        }
    }

    return (
        <Grid container spacing={6}>
            <Grid item xs={6}>
                <Input fullWidth type="file" onChange={handleForeground} inputProps={{ accept: "image/png" }}></Input>
            </Grid>
            <Grid item xs={6}>
                {foreground != undefined ? <img src={foreground} style={{ width: "100%" }} />
                    : null}
            </Grid>
        </Grid>
    );
}

//Actual Scene Editor / Configurator
function SceneEditor(props) {
    const moveX = props.moveX;
    const moveY = props.moveY;
    const scale = props.scale;
    const setMoveX = props.setMoveX;
    const setMoveY = props.setMoveY;
    const setScale = props.setScale;

    const defaultWidth = 1920 / 2;
    const defaultHeight = 1080 / 2;


    const moveX2 = moveX / 3;
    const moveY2 = moveY / -3;



    var paddingLeft = defaultWidth * moveX2;
    var paddingTop = defaultHeight * moveY2;


    const handleScale = (event, newValue) => {
        setScale(newValue);
    };
    const handleMoveX = (event, newValue) => {
        setMoveX(newValue);
    };
    const handleMoveY = (event, newValue) => {
        setMoveY(newValue);
    };

    return (<div>
        <h3>In this step you can set the camera position.</h3>
        <Grid container maxWidth="1000px" spacing={3}>
            <Grid item xs={12}>
                <Button fullWidth variant="outlined" onClick={() => {
                    setMoveY(0);
                    setMoveX(0);
                    setScale(1);
                }}>Reset</Button>
            </Grid>
            <Grid item xs={1}>
                MoveY
                <Slider orientation="vertical" min={-4} max={4} value={moveY} step={0.001} onChange={handleMoveY}></Slider>
            </Grid>
            <Grid item xs={10}>
                <div>
                    <div style={{ position: "relative", overflow: "hidden", width: defaultWidth, height: defaultHeight, margin: "50px", backgroundImage: `url(${props.background})`, backgroundPosition: 'center', backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }}>
                        <div style={{ left: paddingLeft, top: paddingTop, transform: "scale(" + scale + ") rotate(90deg)", backgroundColor: "rgba(13, 218, 56, 0.5)", position: "relative" }}>
                            <img src="https://i.pinimg.com/originals/33/48/ab/3348ab2e7c12b7320a685e140df1e830.jpg" style={{ maxWidth: "100%" }}></img>
                        </div>
                        <div style={{ minWidth: defaultWidth, minHeight: defaultHeight, top: "0px", position: "absolute" }}>
                            <img src={props.foreground} style={{ maxWidth: "100%" }}></img>
                        </div>
                    </div>
                </div>
            </Grid>
            <Grid item xs={1}>
                Scale
                <Slider orientation="vertical" min={0} max={2} value={scale} step={0.001} onChange={handleScale}></Slider>
            </Grid>
            <Grid item xs={1}></Grid>
            <Grid item xs={10}>
                MoveX
                <Slider min={-4} max={4} value={moveX} step={0.001} onChange={handleMoveX}></Slider>
            </Grid>
            <Grid item xs={1}></Grid>
        </Grid>
        {props.loading ? <CircularProgress></CircularProgress> : null}
    </div>)
}

